import { NgModule } from '@angular/core';

import { SkewClipPathDirective } from './skewClipPath.directive';

@NgModule({
  exports: [SkewClipPathDirective],
  declarations: [SkewClipPathDirective],
})
export class SkewClipPathModule {}
